import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import { EmailInbox } from '../../../types/emailImport';
import { EmailInboxType } from '../../../constants/enum';

interface CallableSuccess<T> {
  success: boolean;
  data: T;
}

interface IssueEmailInboxParams {
  company_id: string;
  inbox_type: EmailInboxType;
  pattern_id?: string | null;
  name: string;
  allowed_senders?: string[];
  // 出力方式（fileProcessingType）。自動仕分アドレス発行時のみ指定する（#3042 FB対応）。
  file_type?: number;
}

/**
 * 専用受信アドレスを発行する（管理者/運営スタッフ）。
 */
export const issueEmailInbox = async (params: IssueEmailInboxParams): Promise<EmailInbox> => {
  const callable = httpsCallable<IssueEmailInboxParams, CallableSuccess<EmailInbox>>(
    functions,
    'issueEmailInbox',
  );
  const result = await callable(params);
  return result.data.data;
};

interface UpdateEmailInboxParams {
  company_id: string;
  inbox_id: string;
  name?: string;
  allowed_senders?: string[];
  is_enabled?: boolean;
  // 出力方式（fileProcessingType）。編集ダイアログから変更する（#3042 FB対応）。
  file_type?: number;
}

/**
 * 受信アドレスの設定（allowlist・有効フラグ）を更新する。
 */
export const updateEmailInboxSettings = async (params: UpdateEmailInboxParams): Promise<void> => {
  const callable = httpsCallable<UpdateEmailInboxParams, CallableSuccess<{ inbox_id: string }>>(
    functions,
    'updateEmailInboxSettings',
  );
  await callable(params);
};

/**
 * 受信アドレスを削除する。
 */
export const deleteEmailInboxAddress = async (params: {
  company_id: string;
  inbox_id: string;
}): Promise<void> => {
  const callable = httpsCallable<
    { company_id: string; inbox_id: string },
    CallableSuccess<{ inbox_id: string }>
  >(functions, 'deleteEmailInboxAddress');
  await callable(params);
};
